export default __webpack_public_path__ + "static/media/recapture.4a06cdce.jpeg";